export default "__VITE_ASSET__DfVKsO$2__"